





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IOverdueStep } from '@/app/overdue-notice-process';

const STATE_ICONS: Record<string, string | null> = {
  done: 'check',
  actionable: 'exclamation',
  waiting: 'clock',
  idle: null,
};

@Component
export default class OverdueNoticeProcess extends Vue {
  @Prop({ required: true }) private steps!: IOverdueStep[];

  private stepIcon(step: IOverdueStep): string | null {
    return STATE_ICONS[step.state];
  }

  private stepTitle(step: IOverdueStep): string {
    return this.$t(`Invoice.OverdueNotice.Process.Step.${step.key}`) as string;
  }

  private stepExplanation(step: IOverdueStep): string {
    // Translation scopes are PascalCase, entries are the dynamic state.
    const scope = step.key.charAt(0).toUpperCase() + step.key.slice(1);
    // A later reminder has no date to show until the one before it is written.
    const state = step.state === 'waiting' && !step.availableFrom ? 'waitingUnknown' : step.state;

    return this.$t(
      `Invoice.OverdueNotice.Process.Explanation.${scope}.${state}`,
      { date: step.availableFrom },
    ) as string;
  }
}
